import { navigateTo } from 'gatsby-link'
import React from 'react'
import { connect } from 'react-redux'
import Transition from 'react-transition-group/Transition'
import * as PropTypes from 'prop-types'
import { updateSearchString } from '../../state/actions'
import {isDomElement} from '../../util'

import SearchIcon from '../../assets/icons/search-icon'
import CloseIcon from '../../assets/icons/close-icon'

import './search.scss'


class Search extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      searchString: '',
      showSearchBox: false
    }
    this.searchBox = React.createRef()
    this.nameInput = React.createRef()
    this.toggleSearchBox = this.toggleSearchBox.bind(this)
    this.closeSearchBox = this.closeSearchBox.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        searchString: ''
      })
    }

    if (this.state.showSearchBox) {
      document.body.addEventListener('click', this.closeSearchBox)
    } else {
      document.body.removeEventListener('click', this.closeSearchBox)
    }

    if (this.state.showSearchBox) {
      this.nameInput.current.focus()
    }
  }

  toggleSearchBox() {
    this.setState({
      showSearchBox: !this.state.showSearchBox
    })
  }

  closeSearchBox(event) {
     if (!isDomElement(event.target, this.searchBox.current)) {
      document.body.removeEventListener('click', this.closeSearchBox)
      this.setState({
        showSearchBox: false
      })
    }
  }

  onChange(event) {
    this.setState({
      searchString: event.target.value
    })
  }

  onKeyPress(event) {
    const searchString = event.target.value

    if (event.charCode === 13 && searchString.length > 2) {
      this.submit(searchString)
    }
  }

  submit(searchString) {
    this.props.updateSearchString(searchString)
    this.setState({
      searchString: '',
      showSearchBox: false
    })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({searchString})

    navigateTo(`/${this.props.lang}/search`) 
  }

  render() {
    return (
      <div className="header-search" data-cy="search" ref={ this.searchBox }>
        <div className={"search-icon-container " + (this.state.showSearchBox ? 'bg-yellow' : '')} 
             onClick={ this.toggleSearchBox }>
          {this.state.showSearchBox ? <CloseIcon className="close-icon" /> : <SearchIcon className="search-icon" />}
        </div>
        <Transition
          in={this.state.showSearchBox}
          timeout={{enter: 0, exit: 450}}
          mountOnEnter
          unmountOnExit
          appear>
          {state => (
            <div className={"header-search-input-container " + (state === 'entering' || state === 'entered' ? 'enter-searchbox' : '')}>
              <input 
                className="header-search-input" 
                type="text" 
                ref={ this.nameInput }
                placeholder={ this.props.localization('global.search') }
                value={this.state.searchString}
                onChange={event => this.onChange(event) }
                onKeyPress={(event) => this.onKeyPress(event)} />

              <button
                className="search-button"
                disabled={ this.state.searchString.length == 0 }
                onClick={() => this.submit(this.state.searchString)}>
                <SearchIcon className="header-search-input-icon" />
              </button>
            </div>
          )}
        </Transition>
      </div>
    )
  }
}


Search.propTypes = {
  updateSearchString: PropTypes.func.isRequired,
}

const mapStateToProps = ({ searchString }) => {
  return { searchString }
}

const mapDispatchToProps = dispatch => {
  return { 
    updateSearchString: (searchString) => {
      dispatch(updateSearchString(searchString))
    }
  }
}

const ConnectedSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)


export default ConnectedSearch



// WEBPACK FOOTER //
// ./src/components/Search/search.js